import { computed, ref, Ref } from 'vue';
import { useMirCourtSearch } from '@/pages/admin/standartize/main/filters/useMirCourtSearch';

export const useMirCourt = (regionCode: Ref<string|null>) => {

  return useMirCourtSearch(regionCode);

};
